import { render, staticRenderFns } from "./creatTask.vue?vue&type=template&id=1f66c054&"
import script from "./creatTask.vue?vue&type=script&lang=js&"
export * from "./creatTask.vue?vue&type=script&lang=js&"
import style0 from "./creatTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports